import { useCallback, useState } from "react";

const STORAGE_PREFIX = "wave.lastOpened.";

function loadLastOpenedEpochMs(waveId: string): number | undefined {
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + waveId);
    if (!raw) return undefined;
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? value : undefined;
  } catch {
    return undefined;
  }
}

export function useWaveLastOpened() {
  const [revision, setRevision] = useState(0);

  const recordOpen = useCallback((waveId: string) => {
    const id = waveId.trim();
    if (!id) return;
    localStorage.setItem(STORAGE_PREFIX + id, String(Date.now()));
    setRevision((n) => n + 1);
  }, []);

  const lastOpenedEpochMs = useCallback(
    (waveId: string) => {
      void revision;
      return loadLastOpenedEpochMs(waveId);
    },
    [revision],
  );

  return { recordOpen, lastOpenedEpochMs, revision };
}
